import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const BestPriceCupIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M8.80876 12.5052C9.21653 12.7286 9.6901 12.7976 10.1707 12.7976C10.6514 12.7976 11.0804 12.779 11.4828 12.5031M8.80876 12.5052V15.546M8.80876 12.5052C7.82294 11.9651 7.0891 11.2583 6.5439 10.3539M8.80876 15.546H6.17662V18M8.80876 15.546H11.4828M11.4828 12.5031V15.546M11.4828 12.5031C12.5739 11.816 12.9823 11.1059 13.5168 10.3539M11.4828 15.546H14.059V18H15.1164H6.17662M6.17662 18H4.83085M5.05597 3.16078C5.04186 2.78583 5.03112 2.399 5.02311 2L15.1164 2.00001C15.1391 2.44205 15.1532 2.74931 15.1585 3.15827M5.05597 3.16078H2C2.56711 7.59435 3.58106 9.16564 6.5439 10.3539M5.05597 3.16078C5.17616 6.35599 5.54059 8.68951 6.5439 10.3539M15.1585 3.15827H18C17.5194 7.69324 16.5581 9.16564 13.5168 10.3539M15.1585 3.15827C15.1997 6.35819 14.6986 8.69092 13.5168 10.3539"
                stroke={props.htmlColor ?? '#21272E'}
                strokeWidth="1.1"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
        </SvgIcon>
    );
};
